import { EventEmitter } from 'events';
import { Realtime } from './Realtime';
import { Orderbook } from './Orderbook';

export class Bitflyer extends EventEmitter {
  private realtime: Realtime;
  private orderbook = new Orderbook();
  private isChromeExtension = false;
  constructor() {
    super();
    const channels = [
      'lightning_board_snapshot_FX_BTC_JPY',
      'lightning_board_FX_BTC_JPY',
      'lightning_executions_FX_BTC_JPY',
      'lightning_ticker_FX_BTC_JPY',
      'lightning_ticker_BTC_JPY',
    ];
    this.realtime = new Realtime(channels);
    this.realtime.on('snapshot', (data) => {
      if (!this.isChromeExtension) {
        this.orderbook._setSnapshot(data);
        this.emit('orderbook', this.orderbook);
      }
    });
    this.realtime.on('board', (data) => {
      this.orderbook._setBoard(data);
      this.emit('orderbook', this.orderbook);
    });
    this.realtime.on('executions', (data) => {
      this.emit('executions', data);
    });
    this.realtime.on('ticker', (data) => {
      const { ltp, best_bid, best_ask } = data;
      this.emit('ticker', { ltp, best_bid, best_ask });
    });
    this.realtime.on('spot_ticker', (data) => {
      const { ltp } = data;
      this.emit('spotTicker', { ltp });
    });
    window.addEventListener(
      'message',
      (event) => {
        if (event.source !== window) {
          return;
        }

        if (event.data.type && event.data.type === 'FROM_PAGE') {
          this.isChromeExtension = true;
          this.orderbook._setSnapshot(event.data.orderBook);
          this.emit('orderbook', this.orderbook);
        }
      },
      false,
    );
  }
}
